import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Brain, Zap, Shield, Footprints, Dumbbell, Trophy, ChevronDown, Check } from 'lucide-react';
import { CTAButton } from './Shared';
const TOMOS = [{
  num: 1,
  title: 'Arquero PRO Mindset',
  subtitle: 'Herramientas y fundamentos mentales para desarrollar confianza, liderazgo y fortaleza psicológica dentro del arco.',
  icon: Brain,
  items: ['Construcción de mentalidad competitiva para arqueros', 'Técnicas para desarrollar confianza real dentro del arco', 'Métodos para eliminar pensamientos negativos e inseguridad', 'Estrategias para recuperarse rápidamente después del error', 'Sistemas de concentración activa durante todo el partido', 'Técnicas de visualización deportiva aplicadas al rendimiento', 'Ejercicios de programación mental positiva', 'Herramientas de control emocional bajo presión', 'Técnicas de respiración para reducir ansiedad competitiva', 'Rutinas mentales pre partido para entrar enfocado', 'Métodos para competir con seguridad en partidos importantes', 'Desarrollo de lenguaje corporal dominante y seguro', 'Construcción de liderazgo y comunicación defensiva', 'Mentalidad de resiliencia y disciplina competitiva', 'Entrenamiento mental diario para automatizar hábitos ganadores', 'Estrategias psicológicas para penales y momentos decisivos', 'Técnicas de anticipación mental y lectura del juego', 'Métodos de autoconocimiento y evolución competitiva', 'Plan progresivo de entrenamiento mental para arqueros', 'Recursos prácticos de psicología deportiva aplicada al arco']
}, {
  num: 2,
  title: 'Reflejos y Técnica de Parada',
  subtitle: 'Fundamentos técnicos y herramientas prácticas para desarrollar seguridad, reacción y dominio dentro del arco.',
  icon: Zap,
  items: ['Bases técnicas del arquero moderno', 'Posicionamiento inteligente antes del remate', 'Técnicas de parada y blocajes seguros', 'Control de rebotes y recepción del balón', 'Entrenamiento de reflejos y velocidad de reacción', 'Coordinación ojo-mano aplicada al arco', 'Técnicas de desplazamiento lateral y ajuste corporal', 'Métodos de equilibrio y estabilidad dinámica', 'Técnicas correctas de caída y protección física', 'Recuperación rápida después de cada intervención', 'Cobertura inteligente del arco y reducción de ángulos', 'Lectura corporal del rival y anticipación del remate', 'Técnicas de mano a mano y achiques efectivos', 'Métodos de reacción en corta distancia', 'Herramientas para competir bajo presión', 'Corrección de errores técnicos frecuentes', 'Automatización de movimientos y respuestas rápidas', 'Entrenamientos profesionales de reflejos y técnica', 'Simulación de situaciones reales de partido', 'Desarrollo de seguridad, liderazgo y autoridad dentro del área']
}, {
  num: 3,
  title: 'Dominio del Área y Juego Aéreo',
  subtitle: 'Técnicas y estrategias para controlar el área, transmitir seguridad y dominar el juego aéreo como un arquero moderno.',
  icon: Shield,
  items: ['Fundamentos del dominio del área', 'Cobertura inteligente de espacios defensivos', 'Técnicas de juego aéreo y cálculo de trayectorias', 'Timing de salto y coordinación aérea', 'Métodos de salida segura en centros y pelotas divididas', 'Uso correcto de puños y blocajes en altura', 'Técnicas de intervención en córners y pelotas paradas', 'Posicionamiento defensivo en jugadas aéreas', 'Organización táctica del área y línea defensiva', 'Comunicación efectiva con defensores y centrales', 'Desarrollo de liderazgo verbal dentro del área', 'Construcción de presencia y autoridad competitiva', 'Lenguaje corporal dominante del arquero', 'Lectura ofensiva y anticipación de centros peligrosos', 'Toma de decisiones rápidas en jugadas aéreas', 'Gestión del riesgo: cuándo salir y cuándo permanecer', 'Entrenamientos específicos de salto y coordinación aérea', 'Simulación de situaciones reales de presión ofensiva', 'Automatización de movimientos y seguridad aérea', 'Desarrollo de confianza para dominar el área completa']
}, {
  num: 4,
  title: 'Distribución y Juego con los Pies',
  subtitle: 'Herramientas técnicas y tácticas para convertir al arquero en el primer generador de juego del equipo.',
  icon: Footprints,
  items: ['Evolución del arquero moderno y su rol táctico', 'Fundamentos del juego con los pies', 'Técnicas de pases cortos y largos', 'Perfil corporal correcto para recibir y distribuir', 'Control orientado y primer toque seguro', 'Construcción de juego desde el fondo', 'Métodos para superar presión rival', 'Salidas limpias y generación de espacios', 'Distribución estratégica para iniciar ataques', 'Cambios de orientación y juego rápido', 'Lectura táctica y visión global del campo', 'Identificación de líneas de pase seguras', 'Escaneo visual antes de recibir el balón', 'Cómo romper líneas desde el arco', 'Toma de decisiones rápidas bajo presión', 'Métodos para reducir errores en salida', 'Corrección de errores comunes del arquero moderno', 'Comunicación defensiva y liderazgo táctico', 'Entrenamientos profesionales de control y distribución', 'Simulación de escenarios reales de presión competitiva']
}, {
  num: 5,
  title: 'Preparación Física del Arquero',
  subtitle: 'Métodos físicos y rutinas específicas para desarrollar agilidad, potencia, velocidad y resistencia aplicada al arco.',
  icon: Dumbbell,
  items: ['Fundamentos de la preparación física del arquero', 'Capacidades físicas necesarias para el alto rendimiento', 'Evaluación física específica del arquero', 'Desarrollo de fuerza funcional y explosividad', 'Entrenamiento de potencia de salto', 'Métodos para mejorar velocidad lateral y reacción física', 'Ejercicios de agilidad y cambios de dirección', 'Coordinación motriz aplicada al arco', 'Entrenamiento neuromuscular y tiempo de respuesta', 'Activación física competitiva antes del partido', 'Rutinas de movilidad y flexibilidad funcional', 'Prevención de lesiones frecuentes del arquero', 'Técnicas de recuperación muscular y descanso inteligente', 'Desarrollo de resistencia específica para partidos intensos', 'Métodos de recuperación post entrenamiento y competencia', 'Bases de nutrición deportiva e hidratación competitiva', 'Circuitos físicos profesionales para arqueros', 'Entrenamientos pliométricos y explosivos', 'Organización semanal del entrenamiento físico', 'Plan progresivo de evolución física y alto rendimiento']
}, {
  num: 6,
  title: 'Lectura de Partido y Alto Rendimiento',
  subtitle: 'Herramientas tácticas y estratégicas para desarrollar anticipación, inteligencia competitiva y rendimiento de élite dentro del arco.',
  icon: Trophy,
  items: ['Fundamentos de la lectura de juego del arquero moderno', 'Métodos de anticipación táctica y análisis de jugadas', 'Interpretación de movimientos ofensivos rivales', 'Técnicas de posicionamiento avanzado según la jugada', 'Cobertura inteligente de espacios y reducción de ángulos', 'Análisis de delanteros y patrones ofensivos', 'Lectura corporal previa al remate', 'Escaneo visual constante durante el partido', 'Toma de decisiones rápidas bajo presión', 'Automatización de respuestas competitivas', 'Métodos para mejorar la inteligencia táctica', 'Estrategias para controlar partidos importantes', 'Gestión emocional en escenarios de alta presión', 'Preparación mental para competencias decisivas', 'Comunicación táctica y liderazgo competitivo', 'Simulación de escenarios reales de partido', 'Entrenamientos de análisis y resolución táctica', 'Desarrollo de mentalidad de alto rendimiento', 'Seguimiento y evaluación competitiva del arquero', 'Plan progresivo de evolución táctica y profesional']
}];
type TomoCardProps = {
  tomo: (typeof TOMOS)[number];
  index: number;
};
const TomoCard = ({
  tomo,
  index
}: TomoCardProps) => {
  const [open, setOpen] = useState(false);
  const Icon = tomo.icon;
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.3,
    delay: index * 0.04
  }} className="bg-forest-900 border border-forest-800 rounded-xl hover:border-grass-400/50 transition-colors overflow-hidden" data-id="element-126">
      <div className="p-4 md:p-5" data-id="element-127">
        <div className="flex items-start gap-3" data-id="element-128">
          <div className="bg-forest-950 p-2.5 rounded-lg border border-forest-800 shrink-0" data-id="element-129">
            <Icon className="text-grass-400" size={22} data-id="element-130" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-131">
            <div className="text-grass-400 font-anton tracking-wider text-xs mb-0.5" data-id="element-132">
              TOMO {tomo.num}
            </div>
            <h3 className="font-anton text-lg md:text-xl text-white uppercase tracking-wide leading-tight" data-id="element-133">
              {tomo.title}
            </h3>
          </div>
        </div>

        <button onClick={() => setOpen(!open)} className="mt-4 w-full flex items-center justify-between gap-2 bg-forest-950 hover:bg-forest-800 border border-forest-800 hover:border-grass-400/40 text-forest-200 hover:text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors" data-id="element-134">
          <span data-id="element-135">{open ? 'Ocultar contenido' : 'Ver contenido completo'}</span>
          <motion.div animate={{
          rotate: open ? 180 : 0
        }} transition={{
          duration: 0.2
        }} data-id="element-136">
            <ChevronDown size={16} className="text-grass-400" data-id="element-137" />
          </motion.div>
        </button>
      </div>

      <AnimatePresence initial={false} data-id="element-138">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden border-t border-forest-800" data-id="element-139">
            <div className="p-4 md:p-5 space-y-3" data-id="element-140">
              <p className="text-forest-300 text-sm leading-relaxed italic" data-id="element-141">
                {tomo.subtitle}
              </p>
              <ul className="space-y-2 pt-1" data-id="element-142">
                {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-forest-200" data-id="element-143">
                    <Check size={14} className="text-grass-400 shrink-0 mt-0.5" data-id="element-144" />
                    <span data-id="element-145">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
};
export const TomosGrid = () => {
  return <section className="py-14 md:py-20 px-4 bg-forest-950 relative overflow-hidden" data-id="element-146">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-grass-500/5 blur-[80px] rounded-full pointer-events-none" data-id="element-147" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-10 md:mb-14" data-id="element-149">
          <h2 className="font-anton text-3xl md:text-5xl text-grass-400 uppercase tracking-wide" data-id="element-150">
            6 TOMOS QUE VAN A MEJORAR TU RENDIMIENTO
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-151">
          {TOMOS.map((tomo, i) => <TomoCard key={tomo.num} tomo={tomo} index={i} data-id="element-152" />)}
        </div>

        <div className="mt-14 text-center" data-id="element-153">
          <CTAButton data-id="element-154">Quiero acceder a los 6 tomos →</CTAButton>
        </div>
      </div>
    </section>;
};